import type { DefaultFormEventPayload, ProjectType } from "./types";

export const formContextMap = (
	project: ProjectType,
): DefaultFormEventPayload => {
	const formBrand = project === "cp" ? "consumidor-positivo" : "acordo-certo";

	return {
		validation: {
			formContext: {
				formBrand,
				formName: "validation",
				formVersion: "v1",
			},
		},
		"sign-in": {
			formContext: {
				formBrand,
				formName: "sign-in",
				formVersion: "v1",
			},
		},
		"sign-in-cross": {
			formContext: {
				formBrand,
				formName: "sign-in",
				formVersion: "v1",
			},
		},
		"validate-conflicting-email": {
			formContext: {
				formBrand,
				formName: "sign-in",
				formVersion: "v1",
			},
		},
		"sign-up": {
			formContext: {
				formBrand,
				formId: `${formBrand}-sign-up`,
				formName: "sign-up",
				formType: "sign-up",
				formVersion: "v1",
			},
		},
		"sign-up-ncad": {
			formContext: {
				formBrand,
				formId: `${formBrand}-sign-up-ncad`,
				formName: "sign-up-ncad",
				formType: "sign-up-ncad",
				formVersion: "v1",
			},
		},
		"sign-up-partner": {
			formContext: {
				formBrand,
				formId: `${formBrand}-sign-up-partner`,
				formName: "sign-up-partner",
				formType: "sign-up-partner",
				formVersion: "v1",
			},
		},
		"sign-up-ncad-completed": {
			formContext: {
				formBrand,
				formId: `${formBrand}-sign-up-ncad-completed`,
				formName: "sign-up-ncad-completed",
				formType: "sign-up-ncad-completed",
				formVersion: "v1",
			},
		},
		forgotPassword: {
			formContext: {
				formBrand,
				formName: "forgotPassword",
				formVersion: "v1",
			},
		},
		reset: {
			formContext: {
				formBrand,
				formId: `${formBrand}-reset`,
				formName: "reset",
				formType: "reset",
				formVersion: "v1",
			},
		},
		"update-contact": {
			formContext: {
				formBrand,
				formId: `${formBrand}-update-contact`,
				formName: "update-contact",
				formType: "update-contact",
				formVersion: "v1",
			},
		},
		"update-password": {
			formContext: {
				formBrand,
				formId: `${formBrand}-update-password`,
				formName: "update-password",
				formType: "update-password",
				formVersion: "v1",
			},
		},
		"sign-in-unify-password": {
			formContext: {
				formBrand,
				formId: `${formBrand}-unify-password`,
				formName: "sign-in-unify-password",
				formType: "sign-in-unify-password",
				formVersion: "v1",
			},
		},
		"simple-sign-in": {
			formContext: {
				formBrand,
				formId: `simple-${formBrand}`,
				formName: "simple-sign-in",
				formType: "simple-sign-in",
				formVersion: "v1",
			},
		},
		"unlock-protected-feature": {
			formContext: {
				formBrand,
				formId: `${formBrand}-unlock-protected-feature`,
				formName: "unlock-protected-feature",
				formType: "unlock-protected-feature",
				formVersion: "v1",
			},
		},
		"public-email-confirmation": {
			formContext: {
				formBrand,
				formId: `${formBrand}-public-email-confirmation`,
				formName: "public-email-confirmation",
				formType: "public-email-confirmation",
				formVersion: "v1",
			},
		},
		"private-mfa-positive-data": {
			formContext: {
				formBrand,
				formId: `${formBrand}-private-mfa-positive-data`,
				formName: "private-mfa-positive-data",
				formType: "private-mfa-positive-data",
				formVersion: "v1",
			},
		},
	};
};
